import React, { type FC, type PropsWithChildren } from 'react'
import { Typography } from './Typography'
import { colors } from '../styles/colors'

export const ErrorText: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography fontSize={14} style={{ color: colors.danger }}>
      {children}
    </Typography>
  )
}
